import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Systeme from "@/pages/Systeme";
import Pvra from "@/pages/Pvra";
import ArEna from "@/pages/ArEna";
import PineVr from "@/pages/PineVr";
import HotelVr from "@/pages/HotelVr";
import PinePlaces from "@/pages/PinePlaces";
import StandortPruefen from "@/pages/StandortPruefen";
import Ablauf from "@/pages/Ablauf";
import Faq from "@/pages/Faq";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Danke from "@/pages/Danke";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";
import Gruenden from "@/pages/Gruenden";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Cooperations from "@/pages/Cooperations";
import DevProgramm from "@/pages/DevProgramm";
import SalesPartner from "@/pages/SalesPartner";
import AdminContent from "@/pages/AdminContent";
import AdminContentEdit from "@/pages/AdminContentEdit";
import JourneyGuard from "@/pages/journey/JourneyGuard";
import JourneyLayout from "@/pages/journey/JourneyLayout";
import JourneyDashboard from "@/pages/journey/Dashboard";
import JourneyInbox from "@/pages/journey/Inbox";
import JourneyLeadDetail from "@/pages/journey/LeadDetail";
import JourneyLeadNew from "@/pages/journey/LeadNew";
import JourneyQuickAdd from "@/pages/journey/QuickAdd";
import JourneyKanban from "@/pages/journey/Kanban";
import JourneyTasks from "@/pages/journey/Tasks";
import JourneyCalendar from "@/pages/journey/Calendar";
import JourneySettings from "@/pages/journey/Settings";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0B0F10",
                color: "#F5F7F7",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: 0,
              },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/systeme" element={<Systeme />} />
              <Route path="/pvra" element={<Pvra />} />
              <Route path="/ar-ena" element={<ArEna />} />
              <Route path="/pine-vr" element={<PineVr />} />
              <Route path="/hotel-vr" element={<HotelVr />} />
              <Route path="/pine-places" element={<PinePlaces />} />
              <Route path="/standort-pruefen" element={<StandortPruefen />} />
              <Route path="/gruenden" element={<Gruenden />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/cooperations" element={<Cooperations />} />
              <Route path="/dev-programm" element={<DevProgramm />} />
              <Route path="/sales-partner" element={<SalesPartner />} />
              <Route path="/ablauf" element={<Ablauf />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/danke" element={<Danke />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/content/blog/new" element={<AdminContentEdit type="blog" />} />
            <Route path="/admin/content/blog/:id" element={<AdminContentEdit type="blog" />} />
            <Route path="/admin/content/ausschreibungen/new" element={<AdminContentEdit type="ausschreibung" />} />
            <Route path="/admin/content/ausschreibungen/:id" element={<AdminContentEdit type="ausschreibung" />} />
            <Route
              path="/admin/journey"
              element={
                <JourneyGuard>
                  <JourneyLayout />
                </JourneyGuard>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<JourneyDashboard />} />
              <Route path="inbox" element={<JourneyInbox />} />
              <Route path="quick-add" element={<JourneyQuickAdd />} />
              <Route path="leads/new" element={<JourneyLeadNew />} />
              <Route path="leads/:id" element={<JourneyLeadDetail />} />
              <Route path="kanban" element={<JourneyKanban />} />
              <Route path="tasks" element={<JourneyTasks />} />
              <Route path="calendar" element={<JourneyCalendar />} />
              <Route path="settings" element={<JourneySettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
